import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrderTypeReview = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 8.125C11.1837 8.125 12.3155 8.79215 13.0361 9.99902C12.3157 11.2072 11.1845 11.8737 10.001 11.874C8.81787 11.8736 7.68517 11.2073 6.96484 9.99805C7.6856 8.79127 8.81924 8.125 10 8.125ZM10 9.16699C9.53976 9.16699 9.16699 9.53976 9.16699 10C9.16699 10.4602 9.53976 10.833 10 10.833C10.4602 10.833 10.833 10.4602 10.833 10C10.833 9.53976 10.4602 9.16699 10 9.16699Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10 2.08301C14.365 2.08301 17.917 5.63417 17.917 10C17.917 14.365 14.365 17.917 10 17.917C5.635 17.917 2.08301 14.365 2.08301 10C2.08301 5.63417 5.635 2.08301 10 2.08301ZM10 6.875C8.18861 6.875 6.57931 7.97726 5.69434 9.71484C5.6037 9.89286 5.60383 10.1041 5.69434 10.2822C6.57874 12.022 8.18627 13.1224 9.99805 13.124L10 13.125H10.002C11.8157 13.124 13.4241 12.0213 14.3086 10.2822C14.399 10.1042 14.3992 9.89279 14.3086 9.71484C13.4236 7.97697 11.8145 6.875 10 6.875Z",
		fill: "currentColor"
	})]
});
export default SvgOrderTypeReview;
